//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { SAMPLING_CAMPAIGNS_TRACKING_ID } from '@campaigns/constants/sampling/SamplingCampaignsTrackingId';
import { BodyText } from '@components/atoms/text/Text';
import { Modal } from '@components/molecules/modal/Modal';

interface NeedMoreUnitsModalProps {
  closeModal: () => void;
  isModalOpen: boolean;
  onCreateNewPurchase: () => void;
  onReturnToProducts: () => void;
}

export const NeedMoreUnitsModal = ({
  closeModal,
  isModalOpen,
  onCreateNewPurchase,
  onReturnToProducts,
}: NeedMoreUnitsModalProps) => {
  return (
    <Modal
      closeModal={closeModal}
      contents={
        <ContentWrapper>
          <BodyText>
            It looks like you have selected more units than are available for
            your selected purchase option.
          </BodyText>
          <BodyText>
            If you still need this number of units, you can get a quote for this
            campaign and purchase.
          </BodyText>
          <BodyText>Would you like to continue with a new purchase?</BodyText>
        </ContentWrapper>
      }
      isModalOpen={isModalOpen}
      primaryButtonInfo={{
        buttonContent: 'Return To Products',
        onClick: onReturnToProducts,
        trackingId:
          SAMPLING_CAMPAIGNS_TRACKING_ID.NEED_MORE_UNITS_MODAL_RETURN_BUTTON,
      }}
      secondaryButtonInfo={{
        buttonContent: 'Create New Purchase',
        onClick: onCreateNewPurchase,
        trackingId:
          SAMPLING_CAMPAIGNS_TRACKING_ID.NEED_MORE_UNITS_MODAL_CREATE_NEW_BUTTON,
      }}
      shouldIncludeSecondaryButton={true}
      title='Need more units?'
      width='medium'
    />
  );
};

const ContentWrapper = styled.div(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[4]};
`,
);
